import React from "react"
import FieldProto from "../proto/field-proto";

export type FieldManagementPreviewProps = {
    field       : FieldProto,
    option?     : any,
};

export default function FieldManagementPreview(props:FieldManagementPreviewProps):React.ReactElement {

    return <props.field.renderComponents.managementPreview {...props} />

}